import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CD.svg",
  "use": "CD.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CD.svg\"><path d=\"M32.01,8.021a24,24,0,1,1-24,24A24,24,0,0,1,32.01,8.021Zm0,32.9991a8.9992,8.9992,0,1,0-8.9992-8.9992A8.9994,8.9994,0,0,0,32.01,41.02Zm0-15.9988a6.9995,6.9995,0,1,1-6.9992,7A6.9994,6.9994,0,0,1,32.01,25.0213Zm0,9.9993a3,3,0,1,0-2.9995-3A3,3,0,0,0,32.01,35.0206Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol